/*
 * ** WARNING **
 * This file (and all of the files in this folder) is the legacy version of code originally from `src/components/App/App.tsx`.
 * There is a refactored version of this code in `src/rxdb/replication-v2/`.
 * The feature flag `syncEnhancements` is used to toggle between the two versions.
 * **DO NOT MODIFY THIS FILE UNLESS THE CORRESPONDING CHANGES ARE PORTED TO `replication-v2`**
 * See `src/rxdb/replication-v1/README.md` for more details.
 */
import { useInterval } from '@nutrien/minesight-utility-module';

import { useRxDB } from '@/rxdb/useRxDB';

import { useOnlineStatus } from '../../../utilities';

export function useTokenRefresh() {
  const { db } = useRxDB();
  const online = useOnlineStatus();
  // Refresh tokens on 1 hour interval
  useInterval(() => {
    if (db && online) {
      db.refreshTokensOnAllCollections();
    }
  }, 1 * 60 * 60 * 1000);
}
